import { useSigner } from '@thirdweb-dev/react';
import { useAsync } from 'react-use';
import { ethers5Adapter } from 'thirdweb/adapters/ethers5';

export function useAccount() {
  const signer = useSigner();
  const { value } = useAsync(async () => {
    if (!signer) {
      return;
    }

    return await ethers5Adapter.signer.fromEthers({ signer });
  }, [signer]);

  return value;
}
